import { render } from "./squares.vue?vue&type=template&id=074f8cb1&scoped=true"
import script from "./squares.vue?vue&type=script&lang=js"
export * from "./squares.vue?vue&type=script&lang=js"

import "./squares.vue?vue&type=style&index=0&id=074f8cb1&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074f8cb1"]])

export default __exports__